module.exports = __webpack_public_path__ + "static/img/error.e248630.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/error.png
// module id = gE8K
// module chunks = 1